import { handleLogoutForUnAuth } from "./handleLogoutForUnAuth";

export const Getrequestcall = async (apiPath, token) => {
  try {
    let headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    };

    const getResponse = await window.axios.get(`${import.meta.env.REACT_APP_BASE_URL}/${apiPath}`, {
      headers: headers
    });

    if (getResponse?.status === 401) {
      await handleLogoutForUnAuth();
      return;
    }

    return getResponse;
  } catch (err) {
    if (err?.message?.includes("401") || err?.response?.status === 401) {
      await handleLogoutForUnAuth();
      return;
    }
    return err;
  }
};
